import React, { useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import AdminHeader from '../components/admin/AdminHeader';
import { useAuth } from './../context/AuthProvider';
import '../components/admin/styles/AdminEditForms.css';
import '../components/admin/styles/AdminMessages.css';
import '../components/admin/styles/AdminDashboard.css';
import './styles/Admin.css';


const Admin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth(); // Add logout from useAuth hook

  useEffect(() => {
    if (location.pathname === "/admin") {
      navigate("/admin/dashboard");
    }
  }, [location.pathname, navigate]);

  /*
  const handleBack = () => {
    const pathSegments = location.pathname.split("/").filter(Boolean); // Remove empty segments
    
    if (pathSegments.length === 2) {
      // If it's directly under "/admin", go to dashboard
      navigate("/admin/dashboard");
    } else {
      // Otherwise, go back one step
      navigate(-1);
    }
  };
  */

    // Define handleLogout function
  const handleLogout = async () => {
    await logout(); // Call logout function
    navigate('/login'); // Redirect to login page after logout
  };

  const handleBack = () => {
    navigate("/admin/dashboard");
  };

  const showBackButton = 
    location.pathname !== "/admin/dashboard" &&
    !location.pathname.includes("/add") &&
    !location.pathname.includes("/edit");

  return (
    <div className="adminWrapper">
      <Helmet>
        <title>Admin - Website Name</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="admin-back-wrapper">
        <div>
        {showBackButton && (
          <button className="admin-back-button" onClick={handleBack} aria-label="Go back to previous page">
            ⬅️ Back
          </button>
        )}
        </div>
        <div>
          <button onClick={handleLogout} className="admin-back-button logout" aria-label="Logout">
            Logout <i className="fa-solid fa-arrow-right-from-bracket"></i>
          </button>
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default Admin;
